/* eslint-disable no-nested-ternary */
import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import cn from 'classnames';

import closeWhiteIcon from '../../../assets/images/close-icon.svg';
import {
  ColumnTotalStakedAmountTitle,
  ColumnStatusTitle,
  ColumnEstimatedAprTitle,
  ColumnEstimatedDailyRewardsTitle,
  ColumnEarnedRewardsTitle,
} from '../../../components/Stake/column';
import {
  OM,
  OM_V2,
  RFUEL,
  UNI,
  OM_STAKING_MIGRATE_STATUS,
  UNI_V2,
  DOT,
  KSM,
  CHAIN_NAMES,
  ROYA,
  FXF,
  LABS_UNI,
  L3P,
  ROYA_UNI,
  OM_V3,
  BNB_FINE,
  BNB_OM,
  LABS_UNI_SIMPLE,
  LABS,
  PKF,
  KYL,
  RAZE,
  RAZE_ETH_UNI,
  BNB_MIST,
  ROSN,
  BNB_CBD,
  BNB_BBANK,
  BBANK_ETH_UNI,
  BNB_ROSN,
  BONDLY_ETH_UNI,
  BONDLY_WBNB,
  BONDLY_USDT_UNI,
  BONDLY_ETH,
  BONDLY_BSC,
  BITE,
  BCUBE,
  BCUBE_ETH_UNI,
  ALPHA,
  ALPHA_ETH_UNI,
  BITE_ETH_UNI,
  BITE_ETH_INTERVALS,
  MLT,
  BNB_MLT,
  OM_BSC,
  SRFUEL,
  OM_POLYGON,
  OM_ETH_POLYGON,
  ZEN_UST_UNI,
  ZEN_DAI_UNI,
  ZENUSDT_OM_ETH,
  ZENUSDC_UNI_ETH,
  ZEN_WBTC_UNI,
  ZEN_ETH_UNI,
  MERKLE_AIRDROP_NAMES,
  CIRUS,
  SKYRIM,
  GAMER_POLYGON,
  GAMER_WETH_POLYGON,
  L3P_WBNB_UNI,
  // TODO: Uncomment this
  // STFI_WBNB_UNI,
  // STFI,
  // SPWN,
} from '../../../constants/blockchain-constants';
import * as omStakeActions from '../../../actions/om-stake-actions';
import * as omV2StakeActions from '../../../actions/om-v2-stake-actions';
import * as omV3StakeActions from '../../../actions/om-v3-stake-actions';
import * as bnbFineStakeActions from '../../../actions/bnb-fine-stake-actions';
import * as bnbMistStakeActions from '../../../actions/bnb-mist-stake-actions';
import * as bnbCbdStakeActions from '../../../actions/bnb-cbd-stake-actions';
import * as bnbBbankStakeActions from '../../../actions/bnb-bbank-stake-actions';
import * as bnbMltStakeActions from '../../../actions/bnb-mlt-stake-actions';
import * as bnbRosnStakeActions from '../../../actions/bnb-rosn-stake-actions';
import * as bondlyWbnbStakeActions from '../../../actions/bondly-wbnb-stake-actions';
import * as bnbOmStakeActions from '../../../actions/bnb-om-stake-actions';
import * as razeStakeActions from '../../../actions/raze-stake-actions';
import * as sRfuelStakeActions from '../../../actions/srfuel-stake-actions';
import * as biteStakeActions from '../../../actions/bite-stake-actions';
import * as bcubeStakeActions from '../../../actions/bcube-stake-actions';
// import * as spwnStakeActions from '../../../actions/spwn-stake-actions';
import * as alphaStakeActions from '../../../actions/alpha-stake-actions';
import * as alphaEthUniStakeActions from '../../../actions/alpha-eth-uni-stake-actions';
import * as bondlyEthStakeActions from '../../../actions/bondly-eth-stake-actions';
import * as rosnStakeActions from '../../../actions/rosn-stake-actions';
import * as mltStakeActions from '../../../actions/mlt-stake-actions';
import * as omStakeActionsBsc from '../../../actions/om-stake-actions-bsc';
import * as omStakeActionsPolygon from '../../../actions/om-stake-actions-polygon';
import * as omEthStakeActionsPolygon from '../../../actions/om-eth-stake-actions-polygon';
import * as bondlyBscStakeActions from '../../../actions/bondly-bsc-stake-actions';
// TODO: Uncomment this
// import * as stfiWbnbUniStakeActions from '../../../actions/stfi-wbnb-uni-stake-actions';
// import * as stfiStakeActions from '../../../actions/stfi-stake-actions';
import * as l3pWbnbUniStakeActions from '../../../actions/l3p-wbnb-uni-stake-actions';
import * as kylStakeActions from '../../../actions/kyl-stake-actions';
import * as pkfStakeActions from '../../../actions/pkf-stake-actions';
import * as l3pStakeActions from '../../../actions/l3p-stake-actions';
import * as royaStakeActions from '../../../actions/roya-stake-actions';
import * as fxfStakeActions from '../../../actions/fxf-stake-actions';
import * as rfuelStakeActions from '../../../actions/rfuel-stake-actions';
import * as uniStakeActions from '../../../actions/uni-stake-actions';
import * as uniV2StakeActions from '../../../actions/uni-v2-stake-actions';
import * as labsUniSimpleStakeActions from '../../../actions/labs-uni-simple-stake-actions';
import * as labsUniStakeActions from '../../../actions/labs-uni-stake-actions';
import * as labsStakeActions from '../../../actions/labs-stake-actions';
import * as delegatorActions from '../../../actions/delegator-reward-actions';
import * as royaUniStakeActions from '../../../actions/roya-uni-stake-actions';
import * as razeEthUniStakeActions from '../../../actions/raze-eth-uni-stake-actions';
import * as bbankEthUniStakeActions from '../../../actions/bbank-eth-uni-stake-actions';
import * as bondlyEthUniStakeActions from '../../../actions/bondly-eth-uni-stake-actions';
import * as bcubeEthUniStakeActions from '../../../actions/bcube-eth-uni-stake-actions';
import * as bondlyUsdtUniStakeActions from '../../../actions/bondly-usdt-uni-stake-actions';
import * as biteEthUniStakeActions from '../../../actions/bite-eth-uni-stake-actions';
import * as labsGroupStakeActions from '../../../actions/labs-group-stake-actions';
import * as biteEthIntervalsStakeActions from '../../../actions/bite-eth-intervals-stake-actions';
import * as zenDaiUniStakeActions from '../../../actions/zen-dai-uni-stake-actions';
import * as zenUstUniStakeActions from '../../../actions/zen-ust-uni-stake-actions';
import * as zenWbtcUniStakeActions from '../../../actions/zen-wbtc-uni-stake-actions';
import * as zenEthUniStakeActions from '../../../actions/zen-eth-uni-stake-actions';
import * as zenUsdtOmEthStakeActions from '../../../actions/zenusdt-om-eth-stake-actions';
import * as zenUsdcUniEthStakeActions from '../../../actions/zenusdc-uni-eth-stake-actions';
import * as cirusStakeActions from '../../../actions/cirus-stake-actions';
import * as skyrimStakeActions from '../../../actions/skyrim-stake-actions';
import * as gamerStakeActionsPolygon from '../../../actions/gamer-stake-actions-polygon';
import * as gamerWethStakeActionsPolygon from '../../../actions/gamer-weth-stake-actions-polygon';

import OmV1Item from './items/om-v1-item';
import OmV2Item from './items/om-v2-item';
import RfuelItem from './items/rfuel-item';
import UniV1Item from './items/uni-v1-item';
import UniV2Item from './items/uni-v2-item';
import PolkadotItem from './items/polkadot-nominate-item';
import KusamaItem from './items/kusama-nominate-item';
import MaticMerkleAirdropItem from './items/matic-merkle-airdrop-item';
import RoyaUniItem from './items/roya-uni-item';
import RoyaItem from './items/roya-item';
import LabsUniSimpleItem from './items/labs-uni-simple-item';
import OmV1Frame from './frames/om-v1-frame';
import OmV2Frame from './frames/om-v2-frame';
import RfuelFrame from './frames/rfuel-frame';
import UniV1Frame from './frames/uni-v1-frame';
import UniV2Frame from './frames/uni-v2-frame';
import LabsFrame from './frames/labs-frame';
import LabsUniSimpleFrame from './frames/labs-uni-simple-frame';
import PolkadotFrame from './frames/polkadot-nominate-frame';
import KusamaFrame from './frames/kusama-nominate-frame';
import MaticMerkleAirdropFrame from './frames/matic-merkle-airdrop-frame';
import { setActiveAsset } from '../../../actions/staking-actions';
import RoyaUniFrame from './frames/roya-uni-frame';
import { CHAINS_PATHS, TOKENS_PATHS } from '../../../constants/router-constants';
import RoyaFrame from './frames/roya-frame';
import FxfItem from './items/fxf-item';
import FxfFrame from './frames/fxf-frame';
import Tabs from './tabs';
import LabsUniItem from './items/labs-uni-item';
import LabsUniFrame from './frames/labs-uni-frame';
import L3PItem from './items/l3p-item';
import L3PFrame from './frames/l3p-frame';
import OmV3Item from './items/om-v3-item';
import OmV3Frame from './frames/om-v3-frame';
import BnbFineItem from './items/bnb-fine-item';
import BnbOmItem from './items/bnb-om-item';
import BnbFineFrame from './frames/bnb-fine-frame';
import BnbOmFrame from './frames/bnb-om-frame';
import PKFFrame from './frames/pkf-frame';
import LabsItem from './items/labs-item';
import networkConstant from '../../../constants/network.constant';
import PKFItem from './items/pkf-item';
import KylItem from './items/kyl-item';
import KylFrame from './frames/kyl-frame';
import RazeItem from './items/raze-item';
import RazeFrame from './frames/raze-frame';

import s from './card-table.module.scss';
import RazeEthUniItem from './items/raze-eth-uni-item';
import RazeEthUniFrame from './frames/raze-eth-uni-frame';
import BnbMistItem from './items/bnb-mist-item';
import BnbMistFrame from './frames/bnb-mist-frame';
import RosnItem from './items/rosn-item';
import RosnFrame from './frames/rosn-frame';
import BnbCbdItem from './items/bnb-cbd-item';
import BnbBbankItem from './items/bnb-bbank-item';
import BbankEthUniItem from './items/bbank-eth-uni-item';
import BnbCbdFrame from './frames/bnb-cbd-frame';
import BnbBbankFrame from './frames/bnb-bbank-frame';
import BbankEthUniFrame from './frames/bbank-eth-uni-frame';
import BnbRosnItem from './items/bnb-rosn-item';
import BnbRosnFrame from './frames/bnb-rosn-frame';
import BondlyEthUniItem from './items/bondly-eth-uni-item';
import BondlyEthUniFrame from './frames/bondly-eth-uni-frame';
import BondlyWbnbItem from './items/bondly-wbnb-item';
import BondlyWbnbFrame from './frames/bondly-wbnb-frame';
import BondlyUsdtUniItem from './items/bondly-usdt-uni-item';
import BondlyUsdtUniFrame from './frames/bondly-usdt-uni-frame';
import BondlyEthItem from './items/bondly-eth-item';
import BondlyEthFrame from './frames/bondly-eth-frame';
import BondlyBscItem from './items/bondly-bsc-item';
import BondlyBscFrame from './frames/bondly-bsc-frame';
import BiteItem from './items/bite-item';
import BiteFrame from './frames/bite-frame';
import BiteEthUniItem from './items/bite-eth-uni-item';
import BiteEthUniFrame from './frames/bite-eth-uni-frame';
import BiteEthIntervalsItem from './items/bite-eth-intervals-item';
import BiteEthIntervalsFrame from './frames/bite-eth-intervals-frame';
import BcubeItem from './items/bcube-item';
import BcubeFrame from './frames/bcube-frame';

// import SpwnItem from './items/spwn-item';
// import SpwnFrame from './frames/spwn-frame';

import AlphaItem from './items/alpha-item';
import AlphaFrame from './frames/alpha-frame';

import LabsGroupItem from './items/labs-group-item';
import LabsGroupFrame from './frames/labs-group-frame';

import AlphaEthUniItem from './items/alpha-eth-uni-item';
import AlphaEthUniFrame from './frames/alpha-eth-uni-frame';

import BcubeEthUniItem from './items/bcube-eth-uni-item';
import BcubeEthUniFrame from './frames/bcube-eth-uni-frame';

import MltItem from './items/mlt-item';
import MltFrame from './frames/mlt-frame';

import BnbMltItem from './items/bnb-mlt-item';
import BnbMltFrame from './frames/bnb-mlt-frame';

import OmBscItem from './items/om-bsc-item';
import OmBscFrame from './frames/om-bsc-frame';

import OmPolygonItem from './items/om-polygon-item';
import OmPolygonFrame from './frames/om-polygon-frame';

import SRfuelItem from './items/srfuel-item';
import SRfuelFrame from './frames/srfuel-frame';
import ZenUsdtOmEthItem from './items/zenusdt-om-eth-item';
import ZenUsdtOmEthFrame from './frames/zenusdt-om-eth-frame';
import ZenDaiUniItem from './items/zen-dai-uni-item';
import ZenDaiUniFrame from './frames/zen-dai-uni-frame';
import ZenUstUniItem from './items/zen-ust-uni-item';
import ZenUstUniFrame from './frames/zen-ust-uni-frame';
import ZenUsdcUniEthItem from './items/zenusdc-uni-eth-item';
import ZenUsdcUniEthFrame from './frames/zenusdc-uni-eth-frame';
import ZenWbtcUniItem from './items/zen-wbtc-uni-item';
import ZenWbtcUniFrame from './frames/zen-wbtc-uni-frame';
import ZenEthUniItem from './items/zen-eth-uni-item';
import ZenEthUniFrame from './frames/zen-eth-uni-frame';
import OmEthPolygonItem from './items/om-eth-polygon-item';
import OmEthPolygonFrame from './frames/om-eth-polygon-frame';
import { getZenTokensAll } from '../../../actions/lending-actions';
import CirusItem from './items/cirus-item';
import CirusFrame from './frames/cirus-frame';
import SkyrimItem from './items/skyrim-item';
import SkyrimFrame from './frames/skyrim-frame';
import GamerPolygonItem from './items/gamer-polygon-item';
import GamerPolygonFrame from './frames/gamer-polygon-frame';
// TODO: Uncomment this
// import StfiWbnbUniItem from './items/stfi-wbnb-uni-item';
// import StfiWbnbUniFrame from './frames/stfi-wbnb-uni-frame';
// import StfiItem from './items/stfi-item';
// import StfiFrame from './frames/stfi-frame';
import GamerWethPolygonItem from './items/gamer-weth-polygon-item';
import GamerWethPolygonFrame from './frames/gamer-weth-polygon-frame';
import web3Service from '../../../services/web3-service';
import L3pWbnbUniItem from './items/l3p-wbnb-uni-item';
import L3pWbnbUniFrame from './frames/l3p-wbnb-uni-frame';

const CardTable = () => {
  const dispatch = useDispatch();
  const didMount = useRef(false);
  const { activeAsset, activeTab } = useSelector((state) => state.staking);
  const [openStake, setOpenStake] = useState(false);
  const migrateStatus = useSelector((state) => state.OMstake.stake.migrateStatus);
  const { uniBalance } = useSelector((state) => state.token);
  const { networkType, auth } = useSelector((state) => state.account);
  // Name clash cause by new staking pool bad config
  const LABS_GROUP = 'LABS_GROUP';

  const { rewardEarned: uniV1RewardEarned, rewardBalance: uniV1RewardBalance } = useSelector(
    (state) => state.UNIstake.stake,
  );

  const {
    stakeBalance: omV2StakeBalance,
    unstakedBalance: omV2UnstakeBalance,
    earnedRewards: omV2EarnedRewards,
  } = useSelector((state) => state.OMV2stake.stake);

  const isShowUniV1 = uniBalance > 0 || uniV1RewardEarned + uniV1RewardBalance > 0;
  const isShowOmV2 = omV2StakeBalance > 0 || omV2UnstakeBalance > 0 || omV2EarnedRewards > 0;

  const setAsset = (asset) => dispatch(setActiveAsset(asset));

  useEffect(() => {
    if (didMount.current) {
      setOpenStake(true);
    } else {
      didMount.current = true;
    }
  }, [activeAsset]);

  useEffect(() => {
    if (networkType === networkConstant.networkType.binance) {
      dispatch(bnbFineStakeActions.initData());
      dispatch(bnbOmStakeActions.initData());
      dispatch(bnbMistStakeActions.initData());
      dispatch(bnbCbdStakeActions.initData());
      dispatch(bnbBbankStakeActions.initData());
      dispatch(bnbMltStakeActions.initData());
      dispatch(rosnStakeActions.initData());
      dispatch(mltStakeActions.initData());
      dispatch(omStakeActionsBsc.initData());
      dispatch(bnbRosnStakeActions.initData());
      dispatch(bondlyWbnbStakeActions.initData());
      dispatch(bondlyBscStakeActions.initData());
      // TODO: Uncomment this
      // dispatch(stfiWbnbUniStakeActions.initData());
      // dispatch(stfiStakeActions.initData());
      dispatch(l3pWbnbUniStakeActions.initData());
    } else if (networkType === networkConstant.networkType.polygon) {
      dispatch(omStakeActionsPolygon.initData());
      dispatch(omEthStakeActionsPolygon.initData());
      dispatch(gamerStakeActionsPolygon.initData());
      dispatch(delegatorActions.initData(MERKLE_AIRDROP_NAMES.MATIC));
      dispatch(gamerWethStakeActionsPolygon.initData());
    } else {
      dispatch(omStakeActions.initData());
      dispatch(omV2StakeActions.initData());
      dispatch(omV3StakeActions.initData());
      dispatch(pkfStakeActions.initData());
      dispatch(l3pStakeActions.initData());
      dispatch(royaStakeActions.initData());
      dispatch(fxfStakeActions.initData());
      dispatch(rfuelStakeActions.initData());
      dispatch(uniStakeActions.initData());
      dispatch(uniV2StakeActions.initData());
      dispatch(labsUniSimpleStakeActions.initData());
      dispatch(labsUniStakeActions.initData());
      dispatch(labsStakeActions.initData());
      dispatch(delegatorActions.initData(CHAIN_NAMES.POLKADOT));
      dispatch(delegatorActions.initData(CHAIN_NAMES.KUSAMA));
      dispatch(royaUniStakeActions.initData());
      dispatch(kylStakeActions.initData());
      dispatch(razeStakeActions.initData());
      dispatch(sRfuelStakeActions.initData());
      dispatch(biteStakeActions.initData());
      dispatch(razeEthUniStakeActions.initData());
      dispatch(bbankEthUniStakeActions.initData());
      dispatch(bondlyEthUniStakeActions.initData());
      dispatch(bondlyUsdtUniStakeActions.initData());
      dispatch(bondlyEthStakeActions.initData());
      dispatch(biteEthUniStakeActions.initData());
      dispatch(bcubeStakeActions.initData());
      dispatch(alphaStakeActions.initData());
      dispatch(alphaEthUniStakeActions.initData());
      dispatch(labsGroupStakeActions.initData());
      dispatch(biteEthIntervalsStakeActions.initData());
      dispatch(bcubeEthUniStakeActions.initData());
      dispatch(zenUstUniStakeActions.initData());
      dispatch(zenUsdtOmEthStakeActions.initData());
      dispatch(zenDaiUniStakeActions.initData());
      dispatch(zenWbtcUniStakeActions.initData());
      dispatch(zenEthUniStakeActions.initData());
      dispatch(zenUsdcUniEthStakeActions.initData());
      dispatch(cirusStakeActions.initData());
      dispatch(skyrimStakeActions.initData());
      // TODO: Uncomment
      // dispatch(spwnStakeActions.initData());
    }
  }, [dispatch]);

  useEffect(() => {
    if (openStake) {
      document.body.classList.add('mobileOverflow');
    } else {
      document.body.classList.remove('mobileOverflow');
    }
  }, [openStake]);

  useEffect(() => {
    const updateAllZenTokens = async () => {
      if (networkType === networkConstant.networkType.ethereum) {
        await dispatch(getZenTokensAll());
      }
    };
    updateAllZenTokens();
  }, []);

  const onChangeTab = (token) => {
    setAsset(token);
    setOpenStake(true);
  };

  const path = activeTab || window.location.pathname;

  return (
    <div className={s.container}>
      <div className={s.mainContent}>
        <Tabs />
        <div className={s.tableBody}>
          <div className={s.wrap}>
            <ColumnTotalStakedAmountTitle />
            <ColumnStatusTitle />
            <ColumnEstimatedAprTitle />
            <ColumnEstimatedDailyRewardsTitle />
            <ColumnEarnedRewardsTitle />
          </div>
          {networkType === networkConstant.networkType.ethereum && TOKENS_PATHS.includes(path) && (
            <>
              {migrateStatus === OM_STAKING_MIGRATE_STATUS.HIDE_POOL ? (
                isShowOmV2 && (
                  <div className={s.balanceItemWrap}>
                    <OmV2Item onClick={() => onChangeTab(OM_V2)} isActive={activeAsset === OM_V2} />
                  </div>
                )
              ) : (
                <>
                  <div className={s.balanceItemWrap}>
                    <div className={s.balanceItemLabel}>Old OM V1</div>
                    <OmV1Item onClick={() => onChangeTab(OM)} isActive={activeAsset === OM} />
                  </div>
                  {isShowOmV2 && (
                    <div className={s.balanceItemWrap}>
                      <div className={s.balanceItemLabel}>New OM V2</div>
                      <OmV2Item
                        onClick={() => onChangeTab(OM_V2)}
                        isActive={activeAsset === OM_V2}
                      />
                    </div>
                  )}
                </>
              )}
              <div className={s.balanceItemWrap}>
                {migrateStatus !== OM_STAKING_MIGRATE_STATUS.HIDE_POOL && (
                  <div className={s.balanceItemLabel} />
                )}
              </div>
              <div className={s.balanceItemWrap}>
                <OmV3Item isActive={activeAsset === OM_V3} onClick={() => onChangeTab(OM_V3)} />
              </div>
              <div className={s.balanceItemWrap}>
                <ZenUsdtOmEthItem
                  onClick={() => onChangeTab(ZENUSDT_OM_ETH)}
                  isActive={activeAsset === ZENUSDT_OM_ETH}
                />
              </div>
              <div className={s.balanceItemWrap}>
                <ZenUsdcUniEthItem
                  onClick={() => onChangeTab(ZENUSDC_UNI_ETH)}
                  isActive={activeAsset === ZENUSDC_UNI_ETH}
                />
              </div>
              <div className={s.balanceItemWrap}>
                <ZenDaiUniItem
                  onClick={() => onChangeTab(ZEN_DAI_UNI)}
                  isActive={activeAsset === ZEN_DAI_UNI}
                />
              </div>
              <div className={s.balanceItemWrap}>
                <ZenUstUniItem
                  onClick={() => onChangeTab(ZEN_UST_UNI)}
                  isActive={activeAsset === ZEN_UST_UNI}
                />
              </div>
              <div className={s.balanceItemWrap}>
                <ZenWbtcUniItem
                  onClick={() => onChangeTab(ZEN_WBTC_UNI)}
                  isActive={activeAsset === ZEN_WBTC_UNI}
                />
              </div>
              <div className={s.balanceItemWrap}>
                <ZenEthUniItem
                  onClick={() => onChangeTab(ZEN_ETH_UNI)}
                  isActive={activeAsset === ZEN_ETH_UNI}
                />
              </div>
              <div className={s.balanceItemWrap}>
                <RfuelItem onClick={() => onChangeTab(RFUEL)} isActive={activeAsset === RFUEL} />
              </div>
              <div className={s.balanceItemWrap}>
                <SRfuelItem onClick={() => onChangeTab(SRFUEL)} isActive={activeAsset === SRFUEL} />
              </div>
              {isShowUniV1 && (
                <div className={s.balanceItemWrap}>
                  <UniV1Item onClick={() => onChangeTab(UNI)} isActive={activeAsset === UNI} />
                </div>
              )}
              <div className={s.balanceItemWrap}>
                <UniV2Item onClick={() => onChangeTab(UNI_V2)} isActive={activeAsset === UNI_V2} />
              </div>
              <div className={s.balanceItemWrap}>
                <RoyaItem onClick={() => onChangeTab(ROYA)} isActive={activeAsset === ROYA} />
              </div>
              <div className={s.balanceItemWrap}>
                <FxfItem onClick={() => onChangeTab(FXF)} isActive={activeAsset === FXF} />
              </div>
              <div className={s.balanceItemWrap}>
                <RoyaUniItem
                  onClick={() => onChangeTab(ROYA_UNI)}
                  isActive={activeAsset === ROYA_UNI}
                />
              </div>
              <div className={s.balanceItemWrap}>
                <LabsUniItem
                  onClick={() => onChangeTab(LABS_UNI)}
                  isActive={activeAsset === LABS_UNI}
                />
              </div>
              <div className={s.balanceItemWrap}>
                <LabsGroupItem
                  onClick={() => onChangeTab(LABS_GROUP)}
                  isActive={activeAsset === LABS_GROUP}
                />
              </div>
              <div className={s.balanceItemWrap}>
                <LabsUniSimpleItem
                  onClick={() => onChangeTab(LABS_UNI_SIMPLE)}
                  isActive={activeAsset === LABS_UNI_SIMPLE}
                />
              </div>
              <div className={s.balanceItemWrap}>
                <L3PItem onClick={() => onChangeTab(L3P)} isActive={activeAsset === L3P} />
              </div>
              <div className={s.balanceItemWrap}>
                <LabsItem onClick={() => onChangeTab(LABS)} isActive={activeAsset === LABS} />
              </div>
              <div className={s.balanceItemWrap}>
                <PKFItem onClick={() => onChangeTab(PKF)} isActive={activeAsset === PKF} />
              </div>
              <div className={s.balanceItemWrap}>
                <KylItem onClick={() => onChangeTab(KYL)} isActive={activeAsset === KYL} />
              </div>
              <div className={s.balanceItemWrap}>
                <RazeItem onClick={() => onChangeTab(RAZE)} isActive={activeAsset === RAZE} />
              </div>
              <div className={s.balanceItemWrap}>
                <RazeEthUniItem
                  onClick={() => onChangeTab(RAZE_ETH_UNI)}
                  isActive={activeAsset === RAZE_ETH_UNI}
                />
              </div>
              <div className={s.balanceItemWrap}>
                <BbankEthUniItem
                  onClick={() => onChangeTab(BBANK_ETH_UNI)}
                  isActive={activeAsset === BBANK_ETH_UNI}
                />
              </div>
              <div className={s.balanceItemWrap}>
                <BondlyEthUniItem
                  onClick={() => onChangeTab(BONDLY_ETH_UNI)}
                  isActive={activeAsset === BONDLY_ETH_UNI}
                />
              </div>
              <div className={s.balanceItemWrap}>
                <BondlyUsdtUniItem
                  onClick={() => onChangeTab(BONDLY_USDT_UNI)}
                  isActive={activeAsset === BONDLY_USDT_UNI}
                />
              </div>
              <div className={s.balanceItemWrap}>
                <BondlyEthItem
                  onClick={() => onChangeTab(BONDLY_ETH)}
                  isActive={activeAsset === BONDLY_ETH}
                />
              </div>
              <div className={s.balanceItemWrap}>
                <BiteItem onClick={() => onChangeTab(BITE)} isActive={activeAsset === BITE} />
              </div>
              <div className={s.balanceItemWrap}>
                <BiteEthIntervalsItem
                  onClick={() => onChangeTab(BITE_ETH_INTERVALS)}
                  isActive={activeAsset === BITE_ETH_INTERVALS}
                />
              </div>
              <div className={s.balanceItemWrap}>
                <BiteEthUniItem
                  onClick={() => onChangeTab(BITE_ETH_UNI)}
                  isActive={activeAsset === BITE_ETH_UNI}
                />
              </div>
              <div className={s.balanceItemWrap}>
                <BcubeItem onClick={() => onChangeTab(BCUBE)} isActive={activeAsset === BCUBE} />
              </div>
              <div className={s.balanceItemWrap}>
                <BcubeEthUniItem
                  onClick={() => onChangeTab(BCUBE_ETH_UNI)}
                  isActive={activeAsset === BCUBE_ETH_UNI}
                />
              </div>
              <div className={s.balanceItemWrap}>
                <AlphaItem onClick={() => onChangeTab(ALPHA)} isActive={activeAsset === ALPHA} />
              </div>
              <div className={s.balanceItemWrap}>
                <AlphaEthUniItem
                  onClick={() => onChangeTab(ALPHA_ETH_UNI)}
                  isActive={activeAsset === ALPHA_ETH_UNI}
                />
              </div>
              <div className={s.balanceItemWrap}>
                <CirusItem onClick={() => onChangeTab(CIRUS)} isActive={activeAsset === CIRUS} />
              </div>
              <div className={s.balanceItemWrap}>
                <SkyrimItem onClick={() => onChangeTab(SKYRIM)} isActive={activeAsset === SKYRIM} />
              </div>
            </>
          )}

          {networkType === networkConstant.networkType.polygon &&
            auth !== 'wallet_connect' &&
            TOKENS_PATHS.includes(path) && (
              <>
                <div className={s.balanceItemWrap}>
                  <OmPolygonItem
                    onClick={() => onChangeTab(OM_POLYGON)}
                    isActive={activeAsset === OM_POLYGON}
                  />
                </div>
                <div className={s.balanceItemWrap}>
                  <OmEthPolygonItem
                    onClick={() => onChangeTab(OM_ETH_POLYGON)}
                    isActive={activeAsset === OM_ETH_POLYGON}
                  />
                </div>
                <div className={s.balanceItemWrap}>
                  <GamerPolygonItem
                    onClick={() => onChangeTab(GAMER_POLYGON)}
                    isActive={activeAsset === GAMER_POLYGON}
                  />
                </div>
                <div className={s.balanceItemWrap}>
                  <GamerWethPolygonItem
                    onClick={() => onChangeTab(GAMER_WETH_POLYGON)}
                    isActive={activeAsset === GAMER_WETH_POLYGON}
                  />
                </div>
                <div className={s.balanceItemWrap}>
                  <MaticMerkleAirdropItem
                    onClick={() => onChangeTab(MERKLE_AIRDROP_NAMES.MATIC)}
                    isActive={activeAsset === MERKLE_AIRDROP_NAMES.MATIC}
                  />
                </div>
              </>
            )}
          {networkType === networkConstant.networkType.binance &&
            auth !== 'wallet_connect' &&
            TOKENS_PATHS.includes(path) && (
              <>
                <div className={s.balanceItemWrap}>
                  <OmBscItem
                    onClick={() => onChangeTab(OM_BSC)}
                    isActive={activeAsset === OM_BSC}
                  />
                </div>
                <div className={s.balanceItemWrap}>
                  <BnbOmItem
                    onClick={() => onChangeTab(BNB_OM)}
                    isActive={activeAsset === BNB_OM}
                  />
                </div>
                <div className={s.balanceItemWrap}>
                  <BnbFineItem
                    onClick={() => onChangeTab(BNB_FINE)}
                    isActive={activeAsset === BNB_FINE}
                  />
                </div>
                <div className={s.balanceItemWrap}>
                  <BnbMistItem
                    onClick={() => onChangeTab(BNB_MIST)}
                    isActive={activeAsset === BNB_MIST}
                  />
                </div>
                <div className={s.balanceItemWrap}>
                  <RosnItem onClick={() => onChangeTab(ROSN)} isActive={activeAsset === ROSN} />
                </div>
                <div className={s.balanceItemWrap}>
                  <BnbCbdItem
                    onClick={() => onChangeTab(BNB_CBD)}
                    isActive={activeAsset === BNB_CBD}
                  />
                </div>
                <div className={s.balanceItemWrap}>
                  <BnbBbankItem
                    onClick={() => onChangeTab(BNB_BBANK)}
                    isActive={activeAsset === BNB_BBANK}
                  />
                </div>
                <div className={s.balanceItemWrap}>
                  <BnbRosnItem
                    onClick={() => onChangeTab(BNB_ROSN)}
                    isActive={activeAsset === BNB_ROSN}
                  />
                </div>
                <div className={s.balanceItemWrap}>
                  <BondlyWbnbItem
                    onClick={() => onChangeTab(BONDLY_WBNB)}
                    isActive={activeAsset === BONDLY_WBNB}
                  />
                </div>
                <div className={s.balanceItemWrap}>
                  <BondlyBscItem
                    onClick={() => onChangeTab(BONDLY_BSC)}
                    isActive={activeAsset === BONDLY_BSC}
                  />
                </div>
                <div className={s.balanceItemWrap}>
                  <MltItem onClick={() => onChangeTab(MLT)} isActive={activeAsset === MLT} />
                </div>
                <div className={s.balanceItemWrap}>
                  <BnbMltItem
                    onClick={() => onChangeTab(BNB_MLT)}
                    isActive={activeAsset === BNB_MLT}
                  />
                </div>
                {/*TODO: Uncomment this*/}
                {/*<div className={s.balanceItemWrap}>*/}
                {/*  <StfiItem onClick={() => onChangeTab(STFI)} isActive={activeAsset === STFI} />*/}
                {/*</div>*/}
                {/*<div className={s.balanceItemWrap}>*/}
                {/*  <StfiWbnbUniItem*/}
                {/*    onClick={() => onChangeTab(STFI_WBNB_UNI)}*/}
                {/*    isActive={activeAsset === STFI_WBNB_UNI}*/}
                {/*  />*/}
                {/*</div>*/}
                <div className={s.balanceItemWrap}>
                  <L3pWbnbUniItem
                    onClick={() => onChangeTab(L3P_WBNB_UNI)}
                    isActive={activeAsset === L3P_WBNB_UNI}
                  />
                </div>
              </>
            )}
          {CHAINS_PATHS.includes(path) && networkType === networkConstant.networkType.ethereum ? (
            <>
              <div className={s.balanceItemWrap}>
                <PolkadotItem onClick={() => onChangeTab(DOT)} isActive={activeAsset === DOT} />
              </div>
              <div className={s.balanceItemWrap}>
                <KusamaItem onClick={() => onChangeTab(KSM)} isActive={activeAsset === KSM} />
              </div>
            </>
          ) : null}
        </div>
      </div>
      <div className={cn(s.stakeSidebarContainer, { [s.active]: openStake })}>
        <div className={s.stakeSidebar}>
          <div className={s.stakeSidebarHeader}>
            <button onClick={() => setOpenStake(false)} className={s.stakeSidebarClose}>
              <img src={closeWhiteIcon} alt='close' />
            </button>
          </div>
          {activeAsset === OM && <OmV1Frame />}
          {activeAsset === OM_V2 && <OmV2Frame />}
          {activeAsset === OM_V3 && <OmV3Frame />}
          {activeAsset === BNB_FINE && <BnbFineFrame />}
          {activeAsset === BNB_OM && <BnbOmFrame />}
          {activeAsset === RFUEL && <RfuelFrame />}
          {activeAsset === UNI && <UniV1Frame />}
          {activeAsset === UNI_V2 && <UniV2Frame />}
          {activeAsset === DOT && <PolkadotFrame />}
          {activeAsset === KSM && <KusamaFrame />}
          {activeAsset === MERKLE_AIRDROP_NAMES.MATIC && <MaticMerkleAirdropFrame />}
          {activeAsset === ROYA_UNI && <RoyaUniFrame />}
          {activeAsset === ROYA && <RoyaFrame />}
          {activeAsset === FXF && <FxfFrame />}
          {activeAsset === LABS_UNI && <LabsUniFrame />}
          {activeAsset === L3P && <L3PFrame />}
          {activeAsset === LABS && <LabsFrame />}
          {activeAsset === LABS_UNI_SIMPLE && <LabsUniSimpleFrame />}
          {activeAsset === PKF && <PKFFrame />}
          {activeAsset === KYL && <KylFrame />}
          {activeAsset === RAZE && <RazeFrame />}
          {activeAsset === RAZE_ETH_UNI && <RazeEthUniFrame />}
          {activeAsset === BNB_MIST && <BnbMistFrame />}
          {activeAsset === ROSN && <RosnFrame />}
          {activeAsset === BNB_CBD && <BnbCbdFrame />}
          {activeAsset === BNB_BBANK && <BnbBbankFrame />}
          {activeAsset === BBANK_ETH_UNI && <BbankEthUniFrame />}
          {activeAsset === BNB_ROSN && <BnbRosnFrame />}
          {activeAsset === BONDLY_WBNB && <BondlyWbnbFrame />}
          {activeAsset === BONDLY_ETH_UNI && <BondlyEthUniFrame />}
          {activeAsset === BONDLY_USDT_UNI && <BondlyUsdtUniFrame />}
          {activeAsset === BONDLY_ETH && <BondlyEthFrame />}
          {activeAsset === BONDLY_BSC && <BondlyBscFrame />}
          {activeAsset === BITE && <BiteFrame />}
          {activeAsset === BITE_ETH_UNI && <BiteEthUniFrame />}
          {activeAsset === BCUBE && <BcubeFrame />}
          {activeAsset === ALPHA && <AlphaFrame />}
          {activeAsset === LABS_GROUP && <LabsGroupFrame />}
          {activeAsset === BITE_ETH_INTERVALS && <BiteEthIntervalsFrame />}
          {activeAsset === BCUBE_ETH_UNI && <BcubeEthUniFrame />}
          {activeAsset === ALPHA_ETH_UNI && <AlphaEthUniFrame />}
          {/* TODO: Uncomment */}
          {/* {activeAsset === SPWN && <SpwnFrame />} */}
          {activeAsset === MLT && <MltFrame />}
          {activeAsset === BNB_MLT && <BnbMltFrame />}
          {activeAsset === OM_BSC && <OmBscFrame />}
          {activeAsset === SRFUEL && <SRfuelFrame />}
          {activeAsset === OM_POLYGON && <OmPolygonFrame />}
          {activeAsset === OM_ETH_POLYGON && <OmEthPolygonFrame />}
          {activeAsset === GAMER_POLYGON && <GamerPolygonFrame />}
          {activeAsset === GAMER_WETH_POLYGON && <GamerWethPolygonFrame />}
          {activeAsset === ZEN_UST_UNI && <ZenUstUniFrame />}
          {activeAsset === ZEN_WBTC_UNI && <ZenWbtcUniFrame />}
          {activeAsset === ZEN_ETH_UNI && <ZenEthUniFrame />}
          {activeAsset === ZEN_DAI_UNI && <ZenDaiUniFrame />}
          {activeAsset === ZENUSDT_OM_ETH && <ZenUsdtOmEthFrame />}
          {activeAsset === ZENUSDC_UNI_ETH && <ZenUsdcUniEthFrame />}
          {activeAsset === CIRUS && <CirusFrame />}
          {activeAsset === SKYRIM && <SkyrimFrame />}
          {/*TODO: Uncomment this*/}
          {/*{activeAsset === STFI_WBNB_UNI && <StfiWbnbUniFrame />}*/}
          {/*{activeAsset === STFI && <StfiFrame />}*/}
          {activeAsset === L3P_WBNB_UNI && <L3pWbnbUniFrame />}
        </div>
      </div>
    </div>
  );
};

export default CardTable;
